import axios from 'axios';
import type { AnsweringSubscriptionDoc } from '@bb/domain/dist/schemas';

/**
 * Cancels an answering service subscription for a user/org.
 */
const cancelAnsweringServiceSubscription = async (
  subscriptionId: string,
): Promise<AnsweringSubscriptionDoc> => {
  const { data } = await axios.post<AnsweringSubscriptionDoc>(
    `/answering_service/${subscriptionId}/cancel`,
  );
  return data;
};

export default cancelAnsweringServiceSubscription;
